<template>
  <div v-if="data">
    <TopBar pagetitle="订单详情" :back-url="backurl" :right="topBarRight" @rightClick="onCancelOrder" />
    <div class="orderRect">
      <van-row class="titleLine">
        <van-col span="12" class="aboutStr">{{ formatDate(data.timeCreate, "yyyy-MM-dd hh:mm",true) }}</van-col>
        <van-col span="12" class="mainColor textRight state">{{ GetEnumText("Em_OrderState",data.state) }}</van-col>
      </van-row>
      <van-row>
        <van-col span="4"><img class="icon" :src="data.commodityIcon"></van-col>
        <van-col span="1" />
        <van-col span="19">
          <van-row>
            <van-col span="16">
              <div class="title">{{ data.commodityTitle }}</div>
              <div class="specificaion aboutStr"><span v-for="name in data.specificaionNames" :key="name">{{ name }} </span></div>
            </van-col>
            <van-col span="8" class="textRight">
              <span class="price">￥{{ data.price.toFixed(2) }}</span><br>
              <span class="num aboutStr">x{{ data.num }}</span>
            </van-col>
          </van-row>
          <!-- <div class="totalPrice textRight">合计:￥<span>{{ data.totalPrice.toFixed(2) }}</span></div> -->
        </van-col>
      </van-row>
    </div>
    <div class="LineRect">
      <div class="infoLine">
        <div class="lineTitle">订单信息</div>
        <van-row class="line">
          <van-col span="8">订单号</van-col>
          <van-col span="16" class="textRight">{{ data.orderId }}</van-col>
        </van-row>
        <van-row v-if="data.timeFinish!=null" class="line">
          <van-col span="8">完成时间</van-col>
          <van-col span="16" class="textRight"> {{ formatDate(data.timeFinish, "yyyy-MM-dd hh:mm:ss",true) }}</van-col>
        </van-row>
        <van-row v-if="data.timeFinish==null&& data.timeAutoFinish!=null" class="line">
          <van-col span="8">自动完成时间</van-col>
          <van-col span="16" class="textRight"> {{ formatDate(data.timeAutoFinish, "yyyy-MM-dd hh:mm:ss",true) }}</van-col>
        </van-row>

        <van-row class="line">
          <van-col span="8">单价</van-col>
          <van-col span="16" class="textRight">￥{{ data.price.toFixed(2) }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="8">数量</van-col>
          <van-col span="16" class="textRight">x{{ data.num }}</van-col>
        </van-row>
        <van-row v-if="data.priceFreight!=0" class="line">
          <van-col span="8">运费</van-col>
          <van-col span="16" class="textRight">￥{{ data.priceFreight.toFixed(2) }}</van-col>
        </van-row>
        <van-row v-if="data.priceChange!=0" class="line">
          <van-col span="8">折扣</van-col>
          <van-col span="16" class="textRight">￥{{ data.priceChange.toFixed(2) }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="8">总价</van-col>
          <van-col span="16" class="textRight">￥{{ data.totalPrice.toFixed(2) }}</van-col>
        </van-row>
      </div>

      <div class="infoLine">
        <div class="lineTitle">支付信息</div>
        <van-row v-if="data.timeClose!=null && data.state== 'CREATE'" class="line">
          <van-col span="8">交易关闭时间</van-col>
          <van-col span="16" class="textRight"> {{ formatDate(data.timeClose, "yyyy-MM-dd hh:mm:ss",true) }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="8">支付方式</van-col>
          <van-col span="16" class="textRight">{{ GetEnumText("Em_PayType",data.payType) }}</van-col>
        </van-row>
        <van-row v-if="data.payOrderId!=null" class="line">
          <van-col span="8">交易编号</van-col>
          <van-col span="16" class="textRight">{{ data.payOrderId }}</van-col>
        </van-row>
        <van-row v-if="data.payOrderId!=null" class="line">
          <van-col span="8">支付金额</van-col>
          <van-col span="16" class="textRight">￥{{ data.pricePay }}</van-col>
        </van-row>
        <van-row v-if="data.timePay!=null" class="line">
          <van-col span="8">支付时间</van-col>
          <van-col span="16" class="textRight"> {{ formatDate(data.timePay, "yyyy-MM-dd hh:mm:ss",true) }}</van-col>
        </van-row>
      </div>

      <div v-if="data.zip" class="infoLine">
        <div class="lineTitle">物流信息</div>
        <van-row class="line">
          <van-col span="8">收货地址</van-col>
          <van-col span="16" class="textRight">{{ data.area }}{{ data.address }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="8">收件人</van-col>
          <van-col span="16" class="textRight">{{ data.bookMan }} {{ data.bookContact }}</van-col>
        </van-row>
        <van-row v-if="data.freightCode" class="line">
          <van-col span="8">快递公司</van-col>
          <van-col span="16" class="textRight">{{ data.freightCompanyName }}</van-col>
        </van-row>
        <van-row v-if="data.freightCode" class="line">
          <van-col span="8">运单号</van-col>
          <van-col span="16" class="textRight">{{ data.freightCode }}</van-col>
        </van-row>
      </div>
      <div v-if="!data.zip" class="infoLine">
        <div class="lineTitle">联系人</div>
        <van-row class="line">
          <van-col span="8">联系人</van-col>
          <van-col span="16" class="textRight">{{ data.bookMan }}</van-col>
        </van-row>
        <van-row class="line">
          <van-col span="8">联系方式</van-col>
          <van-col span="16" class="textRight">{{ data.bookContact }}</van-col>
        </van-row>
      </div>

      <div v-if="data.students && data.students.length>0" class="infoLine">
        <div class="lineTitle">学员信息<span class="pagebody3 mainColor">(请仔细核对)</span></div>
        <div v-for="item in data.students" :key="item.studentId">
          <van-row class="line">
            <van-col span="8">学员{{ item.studentId }}</van-col>
            <van-col span="16" class="textRight">{{ item.firstName }} {{ item.lastName }}</van-col>
          </van-row>
          <van-row class="line">
            <van-col span="8">生日</van-col>
            <van-col span="16" class="textRight"> {{ formatDate(item.birthday, "yyyy-MM-dd") }}</van-col>
          </van-row>
          <van-row class="line">
            <van-col span="8">邮箱</van-col>
            <van-col span="16" class="textRight"> {{ item.email }}</van-col>
          </van-row>
          <br>
        </div>
      </div>
    </div>
    <div class="EmptyRect" />
    <div class="downButtons">
      <!-- 待支付 -->
      <div v-if="data.state=='CREATE'">
        <van-row>
          <van-col span="16" class="fullLine pagebody1">总金额:<span class="pageTitle1 mainColor">￥{{ data.totalPrice.toFixed(2) }}</span></van-col>
          <van-col span="8"> <van-button type="info" @click="onPay">立即支付</van-button></van-col>
        </van-row>
      </div>
      <!-- 已取消 -->
      <div v-if="data.state=='CANCEL'">
        <van-row>
          <van-col span="8" offset="8"><van-button square type="default" :loading="doButtonLoading" @click="onDeleteOrder">删除订单</van-button></van-col>
          <van-col span="8"> <van-button square type="info" @click="onBuyAgain">再次购买</van-button></van-col>
        </van-row>
      </div>
      <!-- 已支付 -->
      <div v-if="data.state=='PAY' && data.commodityType=='COURSE'">
        <van-row>
          <van-col span="15" class="mainColor fullLine" />
          <van-col span="8" offset="1"> <van-button square type="info" @click="onEditStudentInfo">{{ data.students && data.students.length>0 ?'修改学员信息':'补充学员信息' }}</van-button></van-col>
        </van-row>
      </div>
      <!-- 已确定 -->
      <div v-if="data.state=='CONFIRMED'">
        <van-row>
          <van-col span="15" class="mainColor fullLine" />
          <van-col span="8" offset="1"> <van-button square type="info" @click="onBack">返回</van-button></van-col>
        </van-row>
      </div>
      <!-- 已发货，已收货 -->
      <div v-if="data.state=='SHIPPED' || data.state=='RECEIVED'">
        <van-row>
          <van-col span="15" class="mainColor fullLine" />
          <van-col span="8" offset="1"> <van-button square type="info" :loading="doButtonLoading" @click="onFinish">确认收货</van-button></van-col>
        </van-row>
      </div>
      <!-- 已退款 -->
      <div v-if="data.state=='REFUND'">
        <van-row>
          <van-col span="15" class="mainColor fullLine" />
          <van-col span="8" offset="1"> <van-button square type="info" @click="onBuyAgain">再次购买</van-button></van-col>
        </van-row>
      </div>
      <!-- 已完成 -->
      <div v-if="data.state=='FINISHED'">
        <van-row>
          <van-col span="8" offset="8"><van-button square type="default" @click="onBuyAgain">再次购买</van-button></van-col>
          <van-col span="8"> <van-button square type="info" @click="onComment">{{ data.commentId==null||data.commentId==0?'评价':'追加评价' }}</van-button></van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, GetEnumText, MyNotify } from '@/utils/base'
import { Button, Dialog, Toast } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      backurl: '/store/orderList',
      data: undefined,
      topBarRight: undefined,
      doButtonLoading: false
    }
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.id = this.$route.params.id
    this.loadData()
  },
  methods: {
    formatDate,
    GetEnumText,
    loadData() {
      request({
        url: '/Store/getOrder',
        method: 'get',
        params: { orderId: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        console.log(response.data)
        this.data = response.data
        this.topBarRight = undefined
        if (this.data.state === 'CREATE') {
          this.topBarRight = 'iconclosex'
        }
      })
    },
    onCancelOrder() {
      Dialog.confirm({
        title: '取消订单',
        message: '是否要取消当前订单?',
        cancelButtonText: '保留订单',
        confirmButtonText: '取消订单'
      }).then(() => {
        request({
          url: '/Store/cancelOrder',
          method: 'post',
          data: { orderId: this.id }
        }).then(response => {
          if (!response.success) {
            return
          }
          MyNotify('success', '订单取消成功')
          this.loadData()
        })
      })
    },
    onBuyAgain() {
      if (this.data.commodityType === 'OTHER') {
        MyNotify('info', '该商品不可再次购买')
        return
      }
      this.$router.replace('/store/commodity/' + this.data.commodityId + '?backurl=/store/orderInfo/' + this.id)
    },
    onEditStudentInfo() {
      this.$router.replace('/store/studentList?orderId=' + this.id)
    },
    onBack() {
      this.$router.replace(this.backurl)
    },
    onComment() {
      var url = '/store/orderComment/' + this.id + '?backurl=/store/orderInfo/' + this.id
      if (!this.data.commentId || this.data.commentId === null || this.data.commentId === 0) {
        url += '&isFirst=true'
      }
      this.$router.replace(url)
    },
    onFinish() {
      Dialog.confirm({
        title: '确认收货',
        message: '是否要确认收货当前订单?',
        cancelButtonText: '取消',
        confirmButtonText: '确认收货'
      }).then(() => {
        this.doButtonLoading = true
        request({
          url: '/Store/finishOrder',
          method: 'post',
          data: { orderId: this.id }
        }).then(response => {
          this.doButtonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '订单确认收货成功')
          this.loadData()
        })
      })
    },
    onDeleteOrder() {
      Dialog.confirm({
        title: '删除订单',
        message: '是否要删除当前订单?',
        cancelButtonText: '保留订单',
        confirmButtonText: '删除订单'
      }).then(() => {
        this.doButtonLoading = true
        request({
          url: '/Store/deleteOrder',
          method: 'post',
          data: { orderId: this.id }
        }).then(response => {
          this.doButtonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '订单删除成功')
          this.$router.replace('/store/orderList')
        })
      })
    },

    onPay() {
      var my = this
      my.doPay((data) => {
        var wxconfig = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.config.appId, // 必填，公众号的唯一标识
          timestamp: Number(data.config.timestamp), // 必填，生成签名的时间戳
          nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
          signature: data.config.signature, // 必填，签名，见附录1
          jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        }
        wx.config(wxconfig)
        wx.ready(function() {
          wx.chooseWXPay({
            appId: data.pay.appId,
            timestamp: data.pay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.pay.nonceStr, // 支付签名随机串，不长于 32
            package: data.pay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: data.pay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.pay.paySign, // 支付签名
            success: function(res) {
              // 跳转到支付成功页面有这个页面
              // $this.$router.push({
              //   path: '/success_page',
              //   name: 'success_page'
              // })
              // MyNotify('success', '支付成功')
              Toast.success({
                message: '支付成功',
                duration: 5000,
                mask: true,
                forbidClick: false,
                onClose: function() {
                  my.loadData()
                }
              })
            },
            cancel: function(res) { // 提示引用的是mint-UI里toast
              // Toast('已取消支付')
              MyNotify('info', '已取消支付')
            },
            fail: function(res) {
              MyNotify('info', '支付失败，请重试')
            }
          })
        })
      })
    },
    doPay(callback) {
      request({
        url: '/data/payCreate',
        method: 'post',
        data: {
          payType: 'WECHAT',
          orderId: this.id,
          url: location.href.split('#')[0]
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data)
        }
      })
    }

  }
}
</script>
<style scoped>
.orderRect{
    background-color: #fff;
    border-bottom: 1px solid #dadada;
    padding: 1em 1em;
}
.LineRect{
    background-color: #fff;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #dadada;
    padding: 0.5em 1em;
    margin-top: 0.6em;
}
.orderRect .icon{
    width: 100%;
}
.orderRect .titleLine{
    font-size: 0.8em;
    margin-bottom: 0.8em;
}
.orderRect .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
     font-size: 0.9em;
}
.orderRect .price{
font-size: 0.9em;
}
.orderRect .num{
font-size: 0.8em;
}
.orderRect .specificaion{
    font-size: 0.7em;
}
.orderRect .totalPrice{
font-size: 0.8em;
}
.orderRect .totalPrice span{
font-size: 1.2em;
font-weight: 700;
}
.orderRect .state{
  font-weight: 700;
}

.infoLine  .lineTitle{
  padding: 0.6em 0;

  border-bottom: 1px solid #eaeaea;
  font-weight: 700;
  font-size: 0.9em;
}
.infoLine .line{
  font-size: 0.8em;
  color: #999;
  padding: 0.2em 0;
}
.downButtons{
  height: 49px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: right;
  background-color: #fff;
  border-top: 1px solid #cacaca;
  padding-top: 1px;
}
.downButtons button{
  width: 90%;
  right: 5%;
  top:7px;
  height:34px ;
  line-height: 34px;
}
.downButtons .fullLine{
  line-height: 48px;
}
.EmptyRect{
  height: 60px;
}
</style>

